import { render, staticRenderFns } from "./ServiceType.vue?vue&type=template&id=ecd737bc&scoped=true"
import script from "./ServiceType.vue?vue&type=script&lang=js"
export * from "./ServiceType.vue?vue&type=script&lang=js"
import style0 from "./ServiceType.vue?vue&type=style&index=0&id=ecd737bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd737bc",
  null
  
)

export default component.exports